import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    text: 'Descarga la guía y lee el protocolo LSA esta misma noche.'
  }, {
    num: '2',
    text: 'Mañana, antes de levantarte, dedica 10 minutos a los 7 movimientos "bajo las sábanas".'
  }, {
    num: '3',
    text: 'Bebe el combustible anti-oxidante y disfruta de un día con 60% menos rigidez desde el primer intento.'
  }];
  return <section className="bg-stone-950 text-stone-50 py-24 px-4" data-id="element-81">
      <div className="max-w-4xl mx-auto" data-id="element-82">
        <FadeIn data-id="element-83">
          <h2 className="text-3xl md:text-4xl font-black mb-16 text-center text-stone-50" data-id="element-84">
            Cómo funciona
          </h2>

          <div className="space-y-8" data-id="element-85">
            {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-86">
                <div className="flex flex-col md:flex-row items-center md:items-start gap-6 bg-stone-900 p-8 rounded-2xl border border-stone-800" data-id="element-87">
                  <div className="w-16 h-16 rounded-full bg-amber-600 flex items-center justify-center text-2xl font-black text-white flex-shrink-0 shadow-lg shadow-amber-900/50" data-id="element-88">
                    {step.num}
                  </div>
                  <p className="text-xl md:text-2xl text-stone-300 leading-relaxed text-center md:text-left mt-2" data-id="element-89">
                    {step.text}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}